import $ from 'jquery';

$(document).ready(function() {
    if ($('.js-museum-info-title').length > 0 && $(window).width() > 1023) {
        $('.js-museum-info-title').each(function() {
            if ($(this).height() >= 144) {
                $(this).addClass('small');
            }
        });
    }
});


// WEBPACK FOOTER //
// ./src/js/pages/one-museum/museum-title.js